import { css } from '@/styled-system/css';

/**
 * Show nav controls by default but hide them on touch screens.
 * - We can't use a touch-first approach since Cypress CI tests
 * don't support hover media queries and break if they can't see the
 * nav controls.
 * - Note we're also using `hover` and `pointer` media queries
 * instead of screen size to ensure the nav controls are visible
 * to desktop users who are zoomed in.
 */
export const carouselNavControlsStyles = css.raw({
  'display': 'flex',
  'alignItems': 'start',
  'gap': 'Carousel.Heading.gap.betweenNav',

  '@media (hover: none) and (pointer: coarse)': {
    display: 'none',
  },
});
